if (!global.Promise) global.Promise = require('promise-polyfill').default;
if (!global.fetch) global.fetch = require('isomorphic-unfetch');

import 'core-js/es/object/entries';
import 'core-js/es/number/is-integer';
import 'core-js/es/symbol';
import 'core-js/es/array/from';
import 'intersection-observer';
